import React from "react";

const Footer = () => {
  return (
    <footer>
      <div
        className="mt-5 bg-dark"
        style={{ fontFamily: "'Baloo Bhaijaan 2'" }}
      >
        <div className="container pt-3 pb-2 text-light text-center">
          © 2024 اطلب جميع الحقوق محفوظة
        </div>
      </div>
    </footer>
  );
};

export default Footer;
